module.exports = __webpack_public_path__ + "static/media/blingV3_19.0511c094.png";